"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArticlesCount = void 0;
const ArticlesList_contracts_1 = require("./ArticlesList.contracts");
/**
 * Counts the articles for the passed-in size and version configuration.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.getArticlesCount = (moduleSize, moduleVersion) => {
    const { rowSpan } = moduleSize;
    switch (moduleVersion) {
        case ArticlesList_contracts_1.ArticlesListVersion.Thumbnails: {
            return Math.ceil(rowSpan * 1.5);
        }
        case ArticlesList_contracts_1.ArticlesListVersion.Text:
        default: {
            return rowSpan * 3;
        }
    }
};
//# sourceMappingURL=ArticlesList.helpers.js.map